import React from 'react';

import { SCCUniversalDevice } from '@/comp/StationControlCenter/types/universal-device.types';
import { HeaderContainer } from './Header.styles';
import type { AssetsSalesforceDTO } from '@/store/Station/constants';
import { getConnectivityIcon } from '@/comp/MapBuilder/nodes/nodeWidget/DetailsDrawer/DetailsDrawer.utils';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';
import { useTranslation } from 'react-i18next';
import ActivityIndication from '@/comp/MapBuilder/nodes/nodeWidget/DetailsDrawer/ActivityIndication/ActivityIndication';

interface HeaderProps {
  icon: React.ReactNode;
  label: string;
  device: SCCUniversalDevice;
  currentAsset?: AssetsSalesforceDTO;
}

export const Header = ({ icon, label, device, currentAsset }: HeaderProps) => {
  const { t } = useTranslation();

  const ConnectivityIcon = getConnectivityIcon(device.deviceType, device as unknown as Entity, currentAsset, t);

  return (
    <HeaderContainer>
      <div className="top-row top-padding">
        <div className="asset-type-container">
          {icon}
          <div className="asset-type-label">{label}</div>
        </div>
        <div className="asset-title">
          <div className="name ellipsis">{device.name ?? ''}</div>
          <div className="model ellipsis">{device.model ?? device.modelDisplayName ?? ''}</div>
        </div>
        <div className="connectivity-icon-wrapper">
          <div className="icons-row">{ConnectivityIcon}</div>
          <ActivityIndication entity={device as unknown as Entity} size="small" direction="horizontal" />
        </div>
      </div>
      <div className="horizontal-border"></div>
    </HeaderContainer>
  );
};
